const MAX_EDGE_PX = 2000;
const JPEG_QUALITY = 0.8;

const loadImage = (file) => new Promise((resolve, reject) => {
	const url = URL.createObjectURL(file);
	const image = new Image();
	image.onload = () => {
		URL.revokeObjectURL(url);
		resolve(image);
	};
	image.onerror = () => {
		URL.revokeObjectURL(url);
		reject(new Error('Image load failed'));
	};
	image.src = url;
});

/**
 * Shrinks a camera photo before upload. A phone photo is 12 MP or more, which is
 * far more than a prescription needs and more than the server can open.
 * Falls back to the original file if the photo cannot be shrunk on this device.
 */
export const shrinkImage = async (file) => {
	try {
		const image = await loadImage(file);
		const scale = Math.min(1, MAX_EDGE_PX / Math.max(image.naturalWidth, image.naturalHeight));

		const canvas = document.createElement('canvas');
		canvas.width = Math.round(image.naturalWidth * scale);
		canvas.height = Math.round(image.naturalHeight * scale);

		const ctx = canvas.getContext('2d');
		if (!ctx) return file;

		// white behind a transparent PNG, which would otherwise turn black as a JPEG
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

		const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY));
		if (!blob) return file;

		const name = `${(file.name || 'prescription').replace(/\.[^.]+$/, '')}.jpg`;
		return new File([blob], name, { type: 'image/jpeg' });
	} catch (_) {
		return file;
	}
};
